var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 79.375 79.375",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.14589 0 0 .1446 10.583 2.6458)",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    strokeWidth: 1.8217
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 84.87 0.03-0.01c0-4.73 3.84-8.57 8.58-8.57h223.02v-67.7c0.02-1.96 0.69-3.94 2.05-5.55 3.06-3.62 8.48-4.07 12.1-1.01l150.06 127.4c0.4 0.33 0.77 0.69 1.11 1.1 3.06 3.62 2.61 9.04-1.01 12.1l-149.73 127.12a8.584 8.584 0 0 1-5.97 2.41 8.61 8.61 0 0 1-8.61-8.61v-67.67h-112.01v32.96c-0.03 2.42-1.04 4.83-3.03 6.52l-101.94 87.26a8.543 8.543 0 0 1-6.04 2.48c-4.75 0-8.61-3.85-8.61-8.6zm399 342.6-0.03 0.01c0 4.73-3.84 8.57-8.58 8.57h-223.02v67.71a8.696 8.696 0 0 1-2.05 5.54c-3.06 3.62-8.48 4.07-12.1 1.01l-150.06-127.4c-0.4-0.33-0.77-0.69-1.11-1.09-3.06-3.62-2.61-9.05 1.01-12.11l149.73-127.11a8.584 8.584 0 0 1 5.97-2.41c4.75 0 8.61 3.85 8.61 8.6v67.67h112.01v-32.96a8.703 8.703 0 0 1 3.03-6.52l101.94-87.26a8.604 8.604 0 0 1 6.04-2.48 8.61 8.61 0 0 1 8.61 8.61zm-17.21-8.57v-204.38l-85.2 72.91v37.64a8.6 8.6 0 0 1-8.6 8.6h-129.23a8.6 8.6 0 0 1-8.6-8.6v-57.7l-128.28 108.9 128.28 108.91v-57.71a8.6 8.6 0 0 1 8.6-8.6zm-364.58-325.46v204.39l85.2-72.92v-37.63c0-4.76 3.85-8.61 8.6-8.61h129.23a8.61 8.61 0 0 1 8.61 8.61v57.7l128.27-108.91-128.27-108.91v57.71c0 4.75-3.86 8.6-8.61 8.6z",
    fillRule: "nonzero",
    strokeWidth: 2.2567
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.af27bfb2c8440f449cbf06995feb3cf3.svg";
export { ForwardRef as ReactComponent };